import { apiClient } from "./client";

/** Recent notifications + unread count. */
export async function fetchNotifications(limit = 20) {
  const res = await apiClient.get("/notifications", { params: { limit } });
  return res.data;
}

/** Lightweight unread-count poll (cheaper than fetching the full list). */
export async function fetchUnreadCount() {
  const res = await apiClient.get("/notifications/unread-count");
  return res.data;
}

/** Mark one notification as read. */
export async function markNotificationRead(id) {
  const res = await apiClient.post(`/notifications/${id}/read`, {});
  return res.data;
}

/** Mark all unread notifications as read. */
export async function markAllNotificationsRead() {
  const res = await apiClient.post("/notifications/read-all", {});
  return res.data;
}
